import Vue from 'vue'
import Vuex from 'vuex'
import db from './config/FirebaseInit'
// import firebase from "firebase/app"
import router from './router'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        items:{},
        products:{},
        starterplanproducts:[],
        offers:[],
        shops:[],
        users:[],
        searchResults:{},
        searchLocation:'',
        searchParam:'',
        serVisits:'',
        searchServicesCat:'',
        searchServicesParam:'',
        searchServicesLocation:'',
        cartItems: undefined,
    },
    mutations:{},
    actions:{},
    getters:{
        // getItems: (state) => (cat) => {
        //     db.collection('products').where("owner", "==", firebase.auth().currentUser.uid)
        //     .where('cat', '==', cat).get()
        //     .then(querySnapshot => {
        //        var  newitems = []
        //       querySnapshot.forEach(doc => {
        //         // console.log('this.items.length is', state.items.length)
        //         const data = {
        //           'id' : doc.id,
        //           'name': doc.data().name,
        //           'category': doc.data().cat,
        //           'brand': doc.data().brand,
        //           'price': doc.data().disprice,
        //           'subcategory': doc.data().subcat,
        //           'desc': doc.data().desc,
        //           // 'img': doc.data().img,
        //           // 'otherimgs': doc.data().otherimgs,
        //         }
        //          newitems.push(data)
        //         state.items[cat] = newitems
        //         console.log('state.items[cat]',state.items[cat]) 
        //       })
             
        //       console.log('newitems', newitems)
        //       console.log('state.items',state.items)
             
        //     })
        //     return state.items[cat]
        // }
    },
})


// WEBPACK FOOTER //
// ./src/Store.js